import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ApmService } from '@elastic/apm-rum-angular';
import { ModalLayerComponent } from '@hs/ui-core-layout';
import { NotificationsContainerComponent } from '@hs/ui-core-notifications';
import { TooltipComponent } from '@hs/ui-core-presentation';

import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        TooltipComponent,
        ModalLayerComponent,
        NotificationsContainerComponent,
        RouterOutlet,
    ],
})
export class AppComponent {
    constructor() {
        const service = inject(ApmService);

        service.init({
            serverUrl: `${environment.apm.host}/apm/`,
            environment: environment.apm.environment,
            centralConfig: false,
            serviceName: 'Named Query',
            active: environment.apm.active,
            sendCredentials: true,
        });
    }
}
